import { lazySubscribe, NotificationSubscription } from 'owa-notification';
import SubscriptionParameters from 'owa-service/lib/contract/SubscriptionParameters';
import reminderNotificationAction from '../actions/reminderNotificationAction';

let isSubscriptionInitialized = false;

export default function subscribeToReminderNotifications() {
    if (isSubscriptionInitialized) {
        return;
    }
    isSubscriptionInitialized = true;

    let subscriptionParameters: SubscriptionParameters = {
        NotificationType: 'ReminderNotification',
    };

    let subscription: NotificationSubscription = {
        subscriptionId: 'ReminderNotifications',
        requiresExplicitSubscribe: true,
        subscriptionParameters: subscriptionParameters,
    };

    // subscribe and store the subscription object
    lazySubscribe.importAndExecute(subscription, reminderNotificationAction);
}
